export const PHONE_NUMBER = '02191007710';
export const PHONE_NUMBER_FORMATTED = '021 - 91007710';

export const TOKEN_EXPIRE_TIME = 30;

export const CLIENT_TYPE_ID = 'USER' as const;
export const CLIENT_TYPE_CUSTOMER_APP = 'CUSTOMER_APP' as const;

export const vehicleTypesPersianLabel = {
    CAR: 'ماشین',
    MOTORCYCLE: 'موتورسیکلت'
};

export const vehicleTypesCategoryId = {
    CAR: 1,
    MOTORCYCLE: 2
} as const;

export const farsiCharacters = [
    { id: 1, title: 'الف', value: 'ا' },
    { id: 2, title: 'ب', value: 'ب' },
    { id: 3, title: 'پ', value: 'پ' },
    { id: 4, title: 'ت', value: 'ت' },
    { id: 5, title: 'ث', value: 'ث' },
    { id: 6, title: 'ج', value: 'ج' },
    { id: 8, title: 'ح', value: 'ح' },
    { id: 10, title: 'د', value: 'د' },
    { id: 12, title: 'ر', value: 'ر' },
    { id: 13, title: 'ز', value: 'ز' },
    { id: 15, title: 'س', value: 'س', secondTitle: 'S' },
    { id: 16, title: 'ش', value: 'ش' },
    { id: 17, title: 'ص', value: 'ص', secondTitle: 'W' },
    { id: 18, title: 'ض', value: 'ض' },
    { id: 19, title: 'ط', value: 'ط' },
    { id: 20, title: 'ظ', value: 'ظ' },
    { id: 21, title: 'ع', value: 'ع' },
    { id: 23, title: 'ف', value: 'ف' },
    { id: 24, title: 'ق', value: 'ق' },
    { id: 25, title: 'ک', value: 'ک' },
    { id: 26, title: 'گ', value: 'گ' },
    { id: 27, title: 'ل', value: 'ل' },
    { id: 28, title: 'م', value: 'م' },
    { id: 29, title: 'ن', value: 'ن' },
    { id: 30, title: 'و', value: 'و' },
    { id: 31, title: 'ه', value: 'ه' },
    { id: 32, title: 'ی', value: 'ی', secondTitle: 'D' },
    { id: 35, title: '♿', value: 'ژ', secondTitle: 'ژ' }
];

export const freeZoneFarsiTitles = {
    gheshm: 'قشم',
    kish: 'کیش',
    arvand: 'اروند',
    maku: 'ماکو',
    aras: 'ارس',
    anzali: 'انزلی',
    chabahar: 'چابهار',
    tehran: 'تهران'
};

export const TEHRAN_CITY_ID = 1;
export const KARAJ_CITY_ID = 2;
export const ESFEHAN_CITY_ID = 3;
export const MASHHAD_CITY_ID = 4;
export const RASHT_CITY_ID = 5;

export const defaultCitiesLocations: Record<string, [number, number]> = {
    [TEHRAN_CITY_ID]: [35.6892, 51.389],
    [MASHHAD_CITY_ID]: [36.2605, 59.6168],
    [KARAJ_CITY_ID]: [35.84, 50.9391],
    [ESFEHAN_CITY_ID]: [32.6546, 51.668],
    [RASHT_CITY_ID]: [37.2799, 49.5845]
} as const;

export const PRODUCTS_SORT_AVAILABLE_DESC_AND_SELLING_PRICE_ASC_ID = 'AVAILABLE_DESC_AND_SELLING_PRICE_ASC';

export const inspectionCities = [
    {
        title: 'تهران',
        value: 'تهران',
        id: TEHRAN_CITY_ID,
        location: [35.6892, 51.389]
    },
    {
        title: 'کرج',
        value: 'کرج',
        id: KARAJ_CITY_ID,
        location: [35.84, 50.9391]
    },
    {
        title: 'مشهد',
        value: 'مشهد',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'اصفهان',
        value: 'اصفهان',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'شیراز',
        value: 'شیراز',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'رشت',
        value: 'رشت',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'اهواز',
        value: 'اهواز',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'چابهار',
        value: 'چابهار',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    },
    {
        title: 'تبریز',
        value: 'تبریز',
        infoLabelTitle: 'به‌زودی',
        disabled: true,
        location: [35.6892, 51.389]
    }
] as const;
